import { createContext } from "react";
import { Variant } from "./Variant";

export const AppPageVariantContext = createContext<Variant>("flat");
